<script >
import TablesSlot from "../small_components/tables/TablesSlot.vue";
import DefaultBox from "../slots/DefaultBox.vue";
import SearchInput from "../small_components/SearchInput.vue";
import RouterLinkTo from "../small_components/RouterLinkTo.vue";
import EditIcon from "../icons/EditIcon.vue";
import Switcher from "../small_components/Switcher.vue";
import AsideDashboard from "../small_components/AsideDashboard.vue";
import HeaderBlock from "../parts/HeaderBlock.vue";
import NotifierBlock from "../parts/NotifierBlock.vue";
import {axiosArticles, axiosCommittees, axiosUsers} from "../../helpers/axios_requests";
import calendar_mixin from "../../mixins/calendar_mixin";
import routes_mixin from "../../mixins/routes_mixin";
import InfoBlock from "../small_components/InfoBlock.vue";
import ChevronLeftIcon from "../icons/ChevronLeftIcon.vue";
import Loader from "../small_components/Loader.vue";
import DefaultInput from "../small_components/DefaultInput.vue";
import DefaultTitle from "../small_components/DefaultTitle.vue";
import BadgeBlock from "../slots/BadgeBlock.vue";
import DefaultSelect from "../small_components/DefaultSelect.vue";
import {FORMAT_ERROR_MESSAGE} from "../../helpers/validation_error_message";
import {STATUS_ERROR, STATUS_SUCCESS} from "../../store/modules/notifiocation";
import {ValidationObserver} from "vee-validate";
import DefaultButton from "../small_components/DefaultButton.vue";
import {NEW_ARTICLE_CATEGORY, NEW_COMMITTEE} from "../../helpers/new_objects";
import {mapActions} from "vuex";
import {ROUTES_NAMES} from "../../router";

export default {
  mixins: [calendar_mixin, routes_mixin],

  name: 'CommitteeView',
  components: {
    DefaultButton,
    DefaultSelect,
    BadgeBlock, DefaultTitle,
    DefaultInput,
    Loader, ChevronLeftIcon, InfoBlock,
    NotifierBlock,
    HeaderBlock,
    AsideDashboard,
    Switcher,
    EditIcon,
    RouterLinkTo,
    SearchInput,
    DefaultBox,
    TablesSlot,
    ValidationObserver
  },

  computed: {
  },
  beforeMount() {
  },

  data() {
    return {
      getUserRoleIsAdmin: true,
      loading: true,
      committee: [],
      new_committee: false,
      manager: null,
      employees: [],
      managerName: false,
      employeesLength: 0,
      committees: [],
      parentCommittee: [],
    }
  },

  created() {
    this.loading = false;
    this.fetchCommittee(this.$route.params.id)
    this.fetchCommittees()
  },
  methods: {
    ...mapActions([
      'actionPushNotification'
    ]),
    searchFetchList() {
      return true;
    },

    fillData(data) {
      this.committee = data || []
      if (data.manager) {
        this.manager = data.manager.user ;
      }
      if (data.parent) {
          this.parentCommittee = data.parent;
      }
      this.employeesLength = this.committee.employees.length;
    },

    fetchCommittee(id) {
      this.loading = true
      if (id == 0) {
        this.$set(this, 'committee', NEW_COMMITTEE())
        this.$set(this, 'new_committee', true)
        this.loading = false
        return
      }
      axiosCommittees.get(id)
          .then(r => {
            this.fillData(r.data)
          })
          .finally(() => {
            this.loading = false
          })
    },

    fetchCommittees() {
      this.loading = true
      axiosCommittees.list()
          .then(r => {
            this.committees = r.data.collection || []
          })
          .finally(() => {
            this.loading = false
          })
    },

    changeParent(val) {
      if (val.id == this.$route.params.id) {
        return;
      }
      this.parentCommittee = val;
      this.committee.parent_id = val.id;
    },

    createUpdate() {
      axiosCommittees.createUpdate(this.committee)
          .then((r) => {
            if (r.data.errors) {
              this.$refs.form.setErrors(r.data.errors);
              let message = FORMAT_ERROR_MESSAGE(r.data.errors)
              this.actionPushNotification(
                  {message: message, status: STATUS_ERROR}
              )
              return;
            }
            this.actionPushNotification({message: 'Saved', status: STATUS_SUCCESS})
            if (this.new_committee) {
              this.$router.push({name: ROUTES_NAMES.committees})
            }
          }).catch((r) => {
        console.log(r)
      })
    },
  }
}
</script>

<template>
  <div class="user-layout">
    <badge-block>
    <default-title h_tag="h3">
      {{$t('committees.committee_info')}}
    </default-title>
        <default-box class="position-relative"
          :loader="loading">
        <div class="row dashboard-wrapper  mt-20">
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{$t('committees.committee')}} {{ committee.title }}</h5>
              <div class="card-body">
                <ValidationObserver v-slot="{ invalid, passes }" ref="form">
                <form class="row mt-20"
                      @submit.prevent="passes(createUpdate)">
                  <div class="col-md-12 col-12 mb-10">
                    <default-input
                        :label="$t('tables.title')"
                        v-model="committee.title"
                    />
                  </div>
                  <div class="col-md-12 col-12 mb-10">
                    <label class="default-input">
                      <span title="Manager" class="default-input__label">
                      {{$t('committees.manager')}}
                    </span>
                      <template v-if="manager" class="default-input__block">
                        <router-link-to
                            class="d-inline-block px-10 py-10"
                            :route_params="{id: manager.id}"
                            :route_name="route_names.user">
                          {{manager.name + ' ' + manager.surname}}
                        </router-link-to>
                      </template>
                      <template v-else class="default-input__block">{{$t('committees.no_manager')}}</template>
                    </label>

                  </div>

                  <div
                      class="col-md-12 col-12 mb-10">
                    <router-link-to
                        class="d-inline-block px-10 py-10"
                        :route_params="{id: parentCommittee.id}"
                        :route_name="route_names.committee">
                      <edit-icon/>
                    </router-link-to>
                    <default-select
                        searchable
                        :placeholder="$t('committees.parent')"
                        :selected_val="parentCommittee"
                        display_item_api_key="title"
                        :list_outer="committees"
                        @change="changeParent"
                    />
                  </div>
                  <div class="text-end mt-20 sticky-bottom">
                    <default-button
                        button_large
                        type="submit">
                      {{ $t('inputs.save') }}
                    </default-button>
                  </div>
                </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
            <div class="card" v-if="employeesLength > 0">
              <h5 class="card-header">{{$t('committees.employees_table')}}</h5>
              <div class="card-body">
                <div class="table-responsive ">
                  <table class="table">
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">{{$t('inputs.email')}}</th>
                      <th scope="col">{{$t('user.name')}}</th>
                      <th scope="col">{{$t('user.active')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(employee, key) in committee.employees" :key="key">
                      <th scope="row"><span>{{ employee.id }}</span></th>
                      <td><span>{{ employee.email }}</span></td>
                      <td>
                        <router-link-to
                            class="d-inline-block px-10 py-10"
                            :route_params="{id: employee.id}"
                            :route_name="route_names.user">
                          <edit-icon/>
                          {{ employee.name + ' ' + employee.surname }}
                        </router-link-to>
                        </td>
                      <td><span>{{ employee.active }}</span></td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <div class="card" v-else>
              <h5 class="card-header">{{$t('committees.there_are_no_employees')}} </h5>
              <div class="card-body">
              </div>
            </div>
          </div>
          <div v-if="committee.children?.length" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="card">
              <h5 class="card-header">{{$t('committees.child_committees')}}</h5>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">{{$t('tables.title')}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(children, key) in committee.children" :key="key">
                      <th scope="row"><span>{{ children.id }}</span></th>
                      <td>
                          {{ children.title  }}
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </default-box>
      </badge-block>
  </div>


</template>

<style scoped>

</style>